
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket/venues",
      function () {
        return require("private-next-pages/cricket/venues/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket/venues"])
      });
    }
  